export const MapIdsToLabels = (selected = [], options = []) => {
  if (!Array.isArray(selected)) return [];
  if (!Array.isArray(options) || options.length === 0) return selected;

  return selected.map(id => {
    const match = options.find(opt => opt.value === id || opt.id === id);
    return match?.label || id;
  });
};